import React from "react";
import PropTypes from "prop-types";

import BoostReportHeader from "./BoostReportHeader";

import "./NotificationDisplay.scss";

const NotificationDisplay = ({
	children,
	isBoosting,
	isBoostReportExpanded,
	showBoostReportHeader,
	onToggleBoostReport,
	onCloseBoostReport,
	onHoverStart,
	onHoverEnd,
}) => (
	<div className="notification-display-container">
		<div
			className="notification-display"
			onMouseEnter={onHoverStart}
			onMouseLeave={onHoverEnd}
		>
			{showBoostReportHeader && (
				<BoostReportHeader
					isBoosting={isBoosting}
					isExpanded={isBoostReportExpanded}
					onToggle={onToggleBoostReport}
					onClose={onCloseBoostReport}
				/>
			)}
			<div className="notification-display-body">
				{children}
			</div>
		</div>
	</div>
);

NotificationDisplay.propTypes = {
	children: PropTypes.any,
	isBoosting: PropTypes.bool,
	isBoostReportExpanded: PropTypes.bool,
	showBoostReportHeader: PropTypes.bool,
	onToggleBoostReport: PropTypes.func,
	onCloseBoostReport: PropTypes.func,
	onHoverStart: PropTypes.func,
	onHoverEnd: PropTypes.func,
};

NotificationDisplay.defaultProps = {
	children: null,
	isBoosting: false,
	isBoostReportExpanded: false,
	showBoostReportHeader: false,
	onToggleBoostReport: undefined,
	onCloseBoostReport: undefined,
	onHoverStart: undefined,
	onHoverEnd: undefined,
};

export default NotificationDisplay;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/components/NotificationDisplay.jsx